import { makeStyles } from "@material-ui/core/styles";

export function useHomeAdminStyles() {
    const useStyles = makeStyles((theme) => ({
        root: {
            width: "100%",
            display: "flex",
            maxHeight: 68,
            alignItems: "center",
        },
        contentIcon: {
            width: 64,
            height: 64,
            backgroundColor: theme.palette.primary.main,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.common.white,
        },
        contentText: {
            marginLeft: 16,
        },
        title: {
            fontSize: 24,
            fontWeight: 400,
        },
        subtitle: {
            fontSize: 16,
            fontWeight: 400,
            color: "#706E7A",
        },
        contentQuickAccess: {
            marginTop: 32,
            width: "100%",
            maxWidth: 1120,
        },
        titleQuickAccess: {
            fontSize: 24,
            fontWeight: 400,
            color: "#333333",
        },
        contentQuickAccessItems: {
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: 24,
            marginTop: 12,
        },
        contentQuickAccessItem: {
            display: "flex",
            cursor: "pointer",
            width: "100%",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: 160,
            backgroundColor: "#F5F5F5",
            borderRadius: 5,
            padding: 16,
        },
        titleQuickAccessItem: {
            margin: "8px 0px",
            fontSize: "1.25rem",
            fontWeight: 500,
            color: "#333333",
        },
        subtitleQuickAccessItem: {
            fontSize: 14,
            textAlign: "center",
            fontWeight: 400,
            color: "#706E7A",
        },
    }));

    const classes = useStyles();

    return {
        classes,
    };
}
